import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import Tooltip from '../../Tooltip'

const styles = theme => ({
  root: {
    whiteSpace: 'nowrap',
    height: '36px',
    padding: '0 16px',
    fontWeight: theme.typography.fontWeightBold,
    '&.rowActionItem': {
      fontSize: theme.typography.fontSizeSmaller,
      fontWeight: theme.typography.fontWeightNormal,
      height: 30,
      minWidth: 30,
      padding: '0 14px',
      'button + &': {
        marginLeft: 10,
        '.buttonGroup &': {
          marginLeft: 1,
        },
      },
    },
    '& a': {
      fontWeight: '300',
    },
    '& a:hover': {
      textDecoration: 'none',
    },
  },
})

function ClassNames(props) {
  const { className, onClick, variant, toolTip, placement, ...rest } = props
  const btn = (
    <Button
      variant={variant}
      color="primary"
      className={cn(props.classes.root, className)}
      style={{ ...props.style }}
      onClick={onClick}
      {...rest}
    >
      {props.children ? props.children : 'class names'}
    </Button>
  )
  const wrapToolTip = toolTip ? (
    <Tooltip content={toolTip} placement={placement}>
      {btn}
    </Tooltip>
  ) : (
    btn
  )
  return wrapToolTip
}

ClassNames.defaultProps = {
  variant: 'contained',
}

const PrimaryButton = withStyles(styles)(ClassNames)
PrimaryButton.displayName = 'PrimaryButton'
export default PrimaryButton
